import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { environment } from '../../environments/environment';
import { IBms } from '../models/bms';

@Injectable({
  providedIn: 'root',
})
export class Bms {
  private baseUrl: string = `${environment.apiUrl}/bms`;
  private http: HttpClient = inject(HttpClient);

  //signals for state
  bmsList = signal<IBms[]>([]);
  isLoading = signal(false);
  errorMessage = signal('');

  getBMSList(controllerId: number): void {
    this.isLoading.set(true);
    this.errorMessage.set('');

    this.http
      .get<IBms[]>(`${this.baseUrl}/controller/${controllerId}`)
      .subscribe({
        next: (data) => {
          this.bmsList.set(data);
          this.isLoading.set(false);
        },
        error: (err) => {
          console.error(err);
          this.errorMessage.set('Failed to load BMSList.');
          this.isLoading.set(false);
        },
      });
  }

  updateFromSocket(data: IBms[]) {
    this.bmsList.set(data);
  }
}
